import { render, staticRenderFns } from "./CheckIcon.vue?vue&type=template&id=10429cb4&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../mobile.zyp.one/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports